import styled from "styled-components";

export const ContainerHome = styled.div`

    width: 100%;
    height: 100%;
    overflow-x:hidden;

`;







 
 
 